class Footer {
  init = () => {
    const scrollTopButton: HTMLButtonElement = document.querySelector('.footer__button-scroll');

    if (!scrollTopButton) {
      return;
    }

    scrollTopButton.addEventListener('click', (e: MouseEvent) => this.handleScrollTop(e));
  };

  handleScrollTop(e: MouseEvent) {
    e.preventDefault();

    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }
}

const FooterInstance = new Footer();
FooterInstance.init();

export { Footer, FooterInstance };
